import { Component, OnInit, Renderer2, Inject, ViewChild } from '@angular/core';
import { PreviewService } from '../services/preview.service';
import { ActivatedRoute } from '../../../node_modules/@angular/router';
import { AuthorService } from '../services/author.service';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.page.html',
  styleUrls: ['./preview.page.scss'],
})
export class PreviewPage implements OnInit {
  public showHeader = true;
  public projectId: number;
  
  constructor(
    public previewService: PreviewService,
    public route: ActivatedRoute,
    public authorService: AuthorService
  ) {
    
    if (this.projectId == null || this.projectId == undefined) {
      this.showHeader = true;
    } 
  }

  ngOnInit() {
   
  }

  setAnnotations(areAnnotationsEnabled){
    this.previewService.areAnnotationsEnabled = areAnnotationsEnabled;
  }
}